"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAnnotationEditorDiv = void 0;
const UiElements_1 = require("../../ui/UiElements");
function createAnnotationEditorDiv() {
    return new UiElements_1.DivEl()
        .setClass('d-block')
        .setId('annotationEditor');
}
exports.createAnnotationEditorDiv = createAnnotationEditorDiv;
